import styled from 'styled-components';
import colors from '_colors.module.scss';
import { BdsGrid, BdsTypo } from 'blip-ds/dist/blip-ds-react';


export const AccordionContainer = styled(BdsGrid)`
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid ${colors.Border2};
  padding: 0.5rem;
`;

export const DocumentName = styled(BdsTypo)`
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;

  &::part(bds-typo__text) {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const FileNameGrid = styled(BdsGrid)`
  min-width: 0;
  overflow: hidden;
  flex: 1;
`;

export const FlexGrid = styled(BdsGrid)`
  flex: 1;
`;

export const TagWrapper = styled.div`
  width: 8.5rem;
`;